module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/campaign_sp-8efb9550065eaf5faf5f1b0d129741c9.png";